<template>
  <v-dialog v-model="eventBus.showServiceModal" max-width="560" scrollable>
    <div class="modal-wrapper">
      <!-- Close button (outside card) -->
      <button class="close-btn" @click="eventBus.showServiceModal = false">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <v-card class="modal-card" flat>
        <v-card-text class="modal-body">
          <!-- Title -->
          <h2 class="modal-title">{{ eventBus.serviceModalData.title }}</h2>

          <!-- Spacer to push text down -->
          <div class="modal-spacer"></div>

          <!-- Text content -->
          <div class="modal-text" v-html="eventBus.serviceModalData.modalDescription || eventBus.serviceModalData.description"></div>

        </v-card-text>
      </v-card>

      <!-- CTA Block (separate, below card) -->
      <div class="modal-cta">
        <h3 class="cta-title">{{ $t('serviceModal.ctaTitle') }}</h3>
        <button class="cta-button" @click="openContact">
          {{ $t('serviceModal.ctaBtn') }}
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3.5 8H12.5M12.5 8L8.5 4M12.5 8L8.5 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { eventBus } from '@/eventBus'

export default {
  name: 'ServiceModal',
  setup() {
    return { eventBus }
  },
  methods: {
    openContact() {
      eventBus.showServiceModal = false
      eventBus.showContactModal = true
    }
  }
}
</script>

<style scoped>
.modal-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.close-btn {
  position: absolute;
  top: 0;
  right: -48px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F1F1F180;
  border: none;
  color: #343330;
  cursor: pointer;
  z-index: 10;
  border-radius: 4px;
  transition: background 0.2s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.modal-card {
  overflow: hidden;
  max-height: 85vh;
  border-radius: 8px;
}

.modal-body {
  padding: 16px 16px 36px;
  display: flex;
  flex-direction: column;
  min-height: 700px;
}

.modal-title {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 32px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 42px;
  color: rgb(28, 165, 190);
  margin: 0;
}

.modal-spacer {
  flex: 1;
}

.modal-text {
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.01em;
  color: rgb(46, 46, 46);
}

.modal-text :deep(p) {
  margin: 0;
}

.modal-text :deep(b) {
  font-weight: 600;
  color: rgb(28, 165, 190);
}

/* CTA Block */
.modal-cta {
  background: rgb(28, 165, 190);
  border-radius: 8px;
  padding: 16px 16px 36px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cta-title {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 32px;
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 41.6px;
  color: rgb(241, 241, 241);
  margin: 0;
}

.cta-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  background: rgb(241, 241, 241);
  color: rgb(46, 46, 46);
  border: none;
  border-radius: 4px;
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.01em;
  cursor: pointer;
  transition: background 0.2s ease;
  width: fit-content;
}

.cta-button:hover {
  background: rgb(255, 255, 255);
}

/* Responsive */
@media (max-width: 960px) {
  .close-btn {
    top: 8px;
    right: 8px;
    color: rgb(46, 46, 46);
  }

  .modal-body {
    padding: 40px 20px 20px !important;
    min-height: auto;
  }

  .modal-title {
    font-size: 24px;
    line-height: 32px;
  }

  .modal-spacer {
    min-height: 40px;
    flex: none;
  }

  .modal-cta {
    padding: 24px 20px;
  }

  .cta-title {
    font-size: 24px;
    line-height: 32px;
  }
}
</style>
